/* Sales-team operations page — visible to Sales Managers, Sub-Admins with the
 * right permission, and Admins (Admins already have the tabs under Settings,
 * but this page groups the SA-facing controls one click away).
 */
import { useEffect, useState } from "react";
import { UserCheck, PhoneCall, Clock, Activity } from "lucide-react";
import { http } from "../api";
import { SaApprovalsTab, CallbacksTab, SaPerformancePanel } from "./SaAdmin";
import { SaPresenceWidget } from "./SyncAdmin";

export default function TeamOps({ user }) {
  const [tab, setTab] = useState("approvals");
  const [teams, setTeams] = useState([]);

  useEffect(() => {
    if (user?.role === "admin" || user?.role === "sub_admin") {
      http.get("/admin/config").then((r) => setTeams(r.data.teams || [])).catch(() => {});
    }
  }, [user]);

  return (
    <>
      <div className="page-intro">
        <div>
          <p className="eyebrow">SALES TEAM / CONTROL PLANE</p>
          <h1>Sales team</h1>
          <p className="muted">Approve Sales Associates, watch callbacks, and monitor performance.</p>
        </div>
      </div>

      <div className="admin-tabs">
        {[
          ["approvals", "SA approvals", UserCheck],
          ["callbacks", "Callbacks", Clock],
          ["performance", "Performance", PhoneCall],
          ["live", "Live", Activity],
        ].map(([id, label, Icon]) => (
          <button
            key={id}
            data-testid={`teamops-${id}-tab`}
            className={tab === id ? "active" : ""}
            onClick={() => setTab(id)}
          >
            <Icon size={13} /> {label}
          </button>
        ))}
      </div>

      {tab === "approvals" && <SaApprovalsTab me={user} teams={teams} />}
      {tab === "callbacks" && <CallbacksTab />}
      {tab === "performance" && <SaPerformancePanel days={30} />}
      {tab === "live" && <SaPresenceWidget />}
    </>
  );
}
